// ─── MERGED THEME: V1 complete + V2 additions ───
export const T = {
  bg: "#0b0d11", bgCard: "#13161c", bgCardHover: "#1a1e26", bgSidebar: "#0f1117",
  bgInput: "#1a1e26", bgTable: "#11141a", bgHover: "#1a1e28",
  border: "#1e2330", borderLight: "#2a3040",
  cyan: "#06b6d4", cyanDark: "#0891b2", cyanLight: "#22d3ee",
  cyanGlow: "rgba(6,182,212,0.15)", cyanDim: "rgba(6,182,212,0.3)",
  green: "#22c55e", greenBg: "rgba(34,197,94,0.12)", greenDim: "rgba(34,197,94,0.3)",
  red: "#ef4444", redBg: "rgba(239,68,68,0.12)", redDim: "rgba(239,68,68,0.3)",
  amber: "#f59e0b", amberBg: "rgba(245,158,11,0.12)", amberDim: "rgba(245,158,11,0.3)",
  orange: "#f97316", orangeBg: "rgba(249,115,22,0.12)",
  yellow: "#eab308", yellowBg: "rgba(234,179,8,0.12)",
  purple: "#a855f7", purpleBg: "rgba(168,85,247,0.12)", purpleDim: "rgba(168,85,247,0.3)",
  blue: "#3b82f6", blueBg: "rgba(59,130,246,0.12)", blueDim: "rgba(59,130,246,0.3)",
  pink: "#ec4899", pinkBg: "rgba(236,72,153,0.12)",
  text: "#e2e8f0", textDim: "#8494a7", textMuted: "#4a5568",
};

export const CHART_COLORS = [T.cyan, T.purple, T.pink, T.orange, T.green, T.yellow, T.blue, T.red, "#22d3ee", "#34d399"];

// V1 Risk/Status color maps
export const RISK_COLORS = { High: T.red, Moderate: T.orange, Low: T.green, Normal: T.green, NULL: T.textMuted };
export const RISK_BG = { High: T.redBg, Moderate: T.orangeBg, Low: T.greenBg, Normal: T.greenBg, NULL: "transparent" };
export const STATUS_COLORS = { Active: T.green, Dormant: T.orange, "Not Active": T.textMuted };

// Trader types
export const TRADER_TYPES = [
  "HeavyTrader", "HighFrequencyTrader", "Scalper", "Hedger",
  "HedgingAbuser", "Swaper", "LongTrader", "NewsTrader", "GainerTrader", "Commissioner"
];
export const TRADER_COLORS = {
  HeavyTrader: "#ef4444", HighFrequencyTrader: "#f97316", Scalper: "#eab308",
  Hedger: "#22c55e", HedgingAbuser: "#ef4444", Swaper: "#3b82f6",
  LongTrader: "#8b5cf6", NewsTrader: "#ec4899", GainerTrader: "#06b6d4", Commissioner: "#a855f7", IP_Abuser: "#f43f5e",
  ArbitrageSuspected: "#ff0055"
};
export const TRADER_ICONS = {
  HeavyTrader: "⚡", HighFrequencyTrader: "🔄", Scalper: "⚡", Hedger: "🛡️",
  HedgingAbuser: "🚨", Swaper: "🔃", LongTrader: "📊", NewsTrader: "📰",
  GainerTrader: "💰", Commissioner: "🏦", ArbitrageSuspected: "⚠️"
};

// Month formatting
const MONTH_NAMES = { "01":"Jan","02":"Feb","03":"Mar","04":"Apr","05":"May","06":"Jun","07":"Jul","08":"Aug","09":"Sep","10":"Oct","11":"Nov","12":"Dec" };
export const fmtMonth = (mk) => { if (!mk) return ""; const s = String(mk); return `${MONTH_NAMES[s.slice(4)] || "?"} ${s.slice(0,4)}`; };

// Number formatting - V1 style (supports decimal places)
export const fmtNum = (n, d = 0) => {
  if (n == null || n === "NULL" || isNaN(Number(n))) return "—";
  const num = Number(n);
  if (d === 0 && Math.abs(num) >= 1e6) return (num / 1e6).toFixed(1) + "M";
  if (d === 0 && Math.abs(num) >= 1e3) return (num / 1e3).toFixed(1) + "K";
  return num.toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
};

export const fmtMoney = (n) => {
  if (n == null || n === "NULL" || isNaN(Number(n))) return "—";
  const num = Math.abs(Number(n));
  const sign = Number(n) < 0 ? "-" : "";
  if (num >= 1e6) return sign + "$" + (num / 1e6).toFixed(1) + "M";
  if (num >= 1e3) return sign + "$" + (num / 1e3).toFixed(1) + "K";
  return sign + "$" + num.toLocaleString(undefined, { maximumFractionDigits: 0 });
};

export const safeNum = (v) => (v == null || v === "NULL" || v === "" || v === "null") ? 0 : (isNaN(Number(v)) ? 0 : Number(v));
export const pctChange = (curr, prev) => prev > 0 ? ((curr - prev) / prev) * 100 : 0;

// V2: Broker Risk Score — config-driven (see riskConfig.js)
import { calcRiskScore, getRiskLevel, getRiskConfig, calcClientGroup, getGroupConfig, saveGroupConfig, resetGroupConfig } from './riskConfig';
export { calcRiskScore, getRiskLevel, getRiskConfig, calcClientGroup, getGroupConfig, saveGroupConfig, resetGroupConfig };
export function calcHealthScore(client) { return calcRiskScore(client).total; }
// 5-level colors: Safe(green) Low(cyan) Elevated(amber) High(orange) Critical(red)
export function healthColor(s) {
  const lvl = getRiskLevel(s);
  return lvl ? lvl.color : T.green;
}
export function healthLabel(s) {
  const lvl = getRiskLevel(s);
  return lvl ? lvl.label : "Safe";
}
